import { PropertyPropsSchema, MetricPropsSchema, NarrativePropsSchema } from '../../graph-schemas/pmn';
import type { NodeDefinition } from './base-crm';

export const PMN_NODES: Record<string, NodeDefinition> = {
  Property: {
    type: 'Property',
    schema: PropertyPropsSchema,
    displayName: 'Property',
    displayNamePlural: 'Properties',
    icon: 'Tag',
    color: '#6b7280',
    formFields: [
      { key: 'name', label: 'Name', type: 'text', required: true },
      { key: 'value', label: 'Value', type: 'text', required: true },
      { key: 'attribute_type', label: 'Type', type: 'select', options: ['string', 'number', 'boolean', 'date', 'url', 'email'] },
      { key: 'category', label: 'Category', type: 'text' },
    ],
    pmnEnabled: false,
  },
  Metric: {
    type: 'Metric',
    schema: MetricPropsSchema,
    displayName: 'Metric',
    displayNamePlural: 'Metrics',
    icon: 'BarChart3',
    color: '#10b981',
    formFields: [
      { key: 'name', label: 'Name', type: 'text', required: true },
      { key: 'value', label: 'Value', type: 'number', required: true },
      { key: 'unit', label: 'Unit', type: 'text' },
      { key: 'date', label: 'Date', type: 'date', required: true },
    ],
    pmnEnabled: false,
  },
  Narrative: {
    type: 'Narrative',
    schema: NarrativePropsSchema,
    displayName: 'Narrative',
    displayNamePlural: 'Narratives',
    icon: 'Lightbulb',
    color: '#f59e0b',
    formFields: [
      { key: 'content', label: 'Content', type: 'textarea', required: true },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'category', label: 'Category', type: 'text' },
      { key: 'source', label: 'Source', type: 'text' },
    ],
    pmnEnabled: false,
  },
};
